// extracted by mini-css-extract-plugin
export default {"app-wrapper":"InQueueApp_app-wrapper__s1Bdo","app-body":"InQueueApp_app-body__5GlxX","app-layout":"InQueueApp_app-layout__0p+zi"};